export * from './date';
export * from './validate';

export const convertToOptions = (dict: Dict): Option[] =>
  Object.entries(dict).map(([value, label]) => ({
    value,
    label,
  }));

export const generateKey = () => {
  return crypto.randomUUID();
};

export const generateImage = (path: string) => {
  const url = `${process.env.REACT_APP_IMAGE_URL}${path}`;
  return url;
};

export const capitalizeFirstLetter = (val: string) => {
  return val.charAt(0).toUpperCase() + val.slice(1);
};

export const convertToSnakeCase = (input: string) => {
  return input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
};
